import React from 'react';
import ContainerValidation from "./Components/ContainerValidation";
import HeaderValidation from "./Components/HeaderValidation";
import {PersonHourglass} from "../../../../components/buttons/IconButtons";
import BodyValidation from "./Components/BodyValidation";
import {Trans, useTranslation} from "react-i18next";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const InvitationOverdue = ({ title, description }) => {
    const { t } = useTranslation();

    return (
        <>
            <ContainerValidation>
                <HeaderValidation showBtnBack={false}/>
                <BodyValidation
                    showBtnNext={false}
                    showBtnPrev={false}
                    showLogoFooter={true}
                >
                    <div className="row">
                        <div className="p-0 col-12 d-flex flex-column justify-content-center align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center mb-2">{title}</p>
                            <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">
                                {description}
                            </p>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center align-items-center">
                        <div className="icon-identity-validation-container">
                            <PersonHourglass className="w-100 h-100" />
                        </div>
                    </div>
                </BodyValidation>
            </ContainerValidation>

        </>
    );
};

export default InvitationOverdue;
